import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import DiscountForm from '../DiscountForm';
import CollapseCard from '@afosto/app-components-react/CollapseCard';
import translations from './translations';

const CollapseAdjustment = ({
  adjustment,
  isOpen,
  onSelect,
  inline,
  isEditing,
  onSubmit,
  onChange,
  onCancel,
  readOnly,
  renderActions,
  removable,
  onRemove,
  onEdit,
}) => {
  const intl = useIntl();

  return (
    <CollapseCard
      title={intl.formatMessage(translations.title)}
      isOpen={isOpen}
      onSelect={onSelect}
      removable={removable}
      onRemove={onRemove}
    >
      <div style={{ padding: 8 }}>
        <DiscountForm
          discount={adjustment}
          renderActions={renderActions}
          onChange={onChange}
          onCancel={onCancel}
          onSubmit={onSubmit}
          onEdit={onEdit}
          inline={inline}
          isEditing={isEditing}
          readOnly={readOnly}
        />
      </div>
    </CollapseCard>
  );
};

CollapseAdjustment.propTypes = {
  adjustment: PropTypes.object,
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  inline: PropTypes.bool,
  isEditing: PropTypes.bool,
  renderActions: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  readOnly: PropTypes.bool,
  removable: PropTypes.bool,
  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
};

CollapseAdjustment.defaultProps = {
  adjustment: {},
  isOpen: false,
  onSelect: undefined,
  inline: true,
  isEditing: false,
  readOnly: false,
  renderActions: true,
  onChange: undefined,
  onSubmit: undefined,
  onCancel: undefined,
  removable: false,
  onRemove: undefined,
  onEdit: undefined,
};

export default CollapseAdjustment;
